var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'has-environment-indicator': !_vm.isProduction,
    'has-chatbox': _vm.shouldDisplayZendeskChatLauncher,
  },attrs:{"id":"app","dir":_vm.currentDirection}},[_c('router-view'),(_vm.shouldDisplayZendeskChatLauncher)?_c('ZendeskButton'):_vm._e(),_c('VerifyPhoneNumber')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }